// the browser only sees VITE_* values; missing Firebase values disable sign-in rather than crashing the map
export const env = {
  apiOrigin: import.meta.env.VITE_API_ORIGIN as string,
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string | undefined,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined,
    appId: import.meta.env.VITE_FIREBASE_APP_ID as string | undefined,
  },
};
